<template>
  <section id="insurance">
    <section-container class="-mt-10 mb-10">
      <div class="text-center">
        <text-h2 class="text-3xl">We accept most insurance, Worker's Comp, No Fault and Liens</text-h2>
      </div>
      <div class="mt-6 flex flex-col items-center gap-3 sm:gap-5">
        <ul
          v-for="(row, index) in rows"
          :key="index"
          role="list"
          class="flex flex-wrap justify-center gap-2 sm:gap-6"
        >
          <li
            v-for="insurer in row"
            :key="insurer.name"
            class="flex"
          >
            <div class="flex items-center">
              <div class="px-4 py-2 text-sm">
                <img v-if="insurer.src" :src="insurer.src" :alt="insurer.name" :class="insurer.class || 'w-28 md:w-40'" />
                <component v-else :is="insurer.logo" :class="insurer.class || 'w-28 md:w-40'" />
              </div>
            </div>
          </li>
        </ul>
      </div>
    </section-container>
  </section>
</template>

<script setup>
import Aetna from "~/assets/images/providers/aetna.svg";
import BlueCross from "~/assets/images/providers/blue-cross.svg";
import Cigna from "~/assets/images/providers/cigna.svg";
import EmpireBlueCross from "~/assets/images/providers/empire-blue-cross.svg";
import HealthFirst from "~/assets/images/providers/health-first.svg";
import Medicare from "~/assets/images/providers/medicare.svg";
import Oxford from "~/assets/images/providers/oxford.svg";
import UnitedHealthCare from "~/assets/images/providers/united.svg";

const rows = [
  [
    { name: "Medicare", logo: Medicare },
    { name: "Empire Blue Cross", logo: EmpireBlueCross, class: "w-24 md:w-32" },
    { name: "Aetna", logo: Aetna },
  ],
  [
    { name: "United Health Care", logo: UnitedHealthCare },
    { name: "Oxford", logo: Oxford },
    { name: "Cigna", logo: Cigna },
  ],
  [
    { name: "Blue Cross", logo: BlueCross },
    { name: "Health First", logo: HealthFirst },
    { name: "Fidelis Care", src: "/images/fidelis.png", class: "h-22 md:h-30 w-auto -my-5 md:-my-8" },
  ],
];
</script>

